import { useContext } from 'react';
import CompanyContext from './context';
import { CompanyProvider } from './provider';

const useCompanyContext = () => {
  const context = useContext(CompanyContext);

  return context;
};

export { useCompanyContext, CompanyProvider, CompanyContext };
